const __WEBPACK_NAMESPACE_OBJECT__ = require("@formatjs/intl-pluralrules/locale-data/ja");